module.exports = __webpack_public_path__ + "static/media/emoji-svgrepo-com (2).f85e9609.svg";